import { useEffect, useRef } from "react";

const FOCABLE = [
  "button:not([disabled])", "[href]", "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])", "textarea:not([disabled])", "[tabindex]:not([tabindex='-1'])",
].join(",");

let contador = 0;

// Un dialogo necesita nombre accesible (WCAG 4.1.2). Si el contenedor no trae
// aria-label ni aria-labelledby, se apunta a su primer titulo (h1-h4 o
// [data-titulo]); sin titulo, queda un nombre generico.
function nombrar(el) {
  if (!el) return;
  if (el.dataset.nombreAuto) { el.removeAttribute("aria-label"); el.removeAttribute("aria-labelledby"); }
  else if (el.hasAttribute("aria-label") || el.hasAttribute("aria-labelledby")) return;
  el.dataset.nombreAuto = "1";
  const t = el.querySelector("[data-titulo],h1,h2,h3,h4");
  if (t) {
    if (!t.id) t.id = "dlg-titulo-" + (++contador);
    el.setAttribute("aria-labelledby", t.id);
  } else {
    el.setAttribute("aria-label", "Ventana de diálogo");
  }
}

// Un modal que se abre tiene que llevar el foco dentro, atrapar el Tab y
// devolverlo al disparador al cerrarse. Escape cierra salvo que otro control
// dentro del modal ya lo haya consumido (preventDefault), como un desplegable.
// `clave` (opcional) vuelve a calcular el nombre cuando cambia el contenido del
// mismo marco, como cuando App pinta otro modal en la misma caja.
export default function useFocoModal(ref, abierto, onCerrar, clave) {
  const cerrarRef = useRef(onCerrar);
  cerrarRef.current = onCerrar;

  useEffect(() => {
    if (!abierto) return;
    const previo = document.activeElement;
    const el = ref.current;
    nombrar(el);
    if (el && !el.contains(document.activeElement)) {
      el.querySelector(FOCABLE)?.focus();
    }

    const onKey = (e) => {
      const caja = ref.current;
      if (!caja) return;
      if (e.key === "Escape" && !e.defaultPrevented) {
        e.preventDefault();
        cerrarRef.current();
        return;
      }
      if (e.key !== "Tab") return;
      const focos = [...caja.querySelectorAll(FOCABLE)];
      if (!focos.length) return;
      const primero = focos[0];
      const ultimo = focos[focos.length - 1];
      const activo = document.activeElement;
      if (!caja.contains(activo)) {
        e.preventDefault();
        (e.shiftKey ? ultimo : primero).focus();
      } else if (e.shiftKey && activo === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && activo === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    };

    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      previo?.focus?.();
    };
  }, [abierto, ref]);

  useEffect(() => {
    if (!abierto) return;
    const el = ref.current;
    nombrar(ref.current);
  }, [clave]);
}
